module.exports = __webpack_public_path__ + "2a35ce64625eb3c5202c4a25ef010d09.png";